import { SignaalBericht } from '@/types/Signalen';
import { QueryFunction, useQuery } from '@tanstack/react-query';

import { useFetchWithAuth } from '../useFetchWithAuth';

export const useGetSignalen = () => {
  const { fetchWithAuth } = useFetchWithAuth();

  const fetcher: QueryFunction<SignaalBericht[]> = async () => {
    const response = await fetchWithAuth('/signalen');
    if (response.status > 499) {
      throw new Error(`Applicatiefout ${response.status}: ${response.statusText}`);
    } else if (!response.ok) {
      return [];
    } else {
      return response.json();
    }
  };

  return useQuery({
    queryKey: ['alleSignalen'],
    queryFn: fetcher,
  });
};
